import cn from 'classnames';
import Arrow from './Arrow';
import styles from './SliderArrows.module.css';

const NavigationArrows = ({
  prevHandler,
  nextHandler,
  wrapperClassName,
  buttonClassName,
  iconSize,
  isPrevEnabled = true,
  isNextEnabled = true,
}) => {
  return (
    <div className={cn(styles.component, wrapperClassName)}>
      <Arrow
        direction="left"
        onClick={prevHandler}
        className={buttonClassName}
        disabled={!isPrevEnabled}
        iconSize={iconSize}
      />
      <Arrow
        direction="right"
        onClick={nextHandler}
        className={buttonClassName}
        disabled={!isNextEnabled}
        iconSize={iconSize}
      />
    </div>
  );
};

export default NavigationArrows;
